import React, { useState, useEffect } from "react";
import TopDestinationMultiRow from "../../../../components/multiRow/TopDestinationMultiRow";
import ContactUs from "./ContactUs";
import BestSeller from "../../homePages/components/BestSeller";
import Sail from "../../../../Asset/image/yacht/Sail.gif";

function BodyContact() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // จำลองโหลดข้อมูล
    const timer = setTimeout(() => {
      setLoading(false); // หลัง 2 วินาที loader จะหาย
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading && (
        <div
          className="overlay"
        >
          <img
            src={Sail}
            alt="Loading..."
            className="img-box"
            draggable={false}
          />
        </div>
      )}

      <div
        className="container"
        style={{ marginTop: "5vh", opacity: loading ? 0.5 : 1 }}
      >
        <div className="row align-items-stretch">
          <div className="col-lg-1 order-md-1 d-none d-lg-block"></div>
          <div className="col-lg-4 text-center order-md-1 mb-4">
            <TopDestinationMultiRow />
          </div>
          <div className="col-lg-1 order-md-2 d-none d-lg-block"></div>
          <div className="col-lg-5 text-center order-md-2 mb-4">
            <ContactUs />
          </div>
          <div className="col-lg-1 order-md-3 d-none d-lg-block"></div>
          <div className="col-lg-12 text-center order-md-3 col-md-12 mb-4">
            <BestSeller />
          </div>
        </div>
      </div>
    </>
  );
}

export default BodyContact;
